/**
 * Upload variant visibility: show .upload-front for Single-Sided Upload,
 * show both .upload-front and .upload-back for Double-Sided Upload.
 * Option fieldset: "Upload Text/Artwork or Launch Virtual Designer"
 */
(function () {
  var UPLOAD_OPTION_HANDLE = 'upload-text-artwork-or-launch-virtual-designer';

  function getSelectedUploadValue(wrapper) {
    var fieldset = wrapper.querySelector('.variant-input-wrap[data-handle="' + UPLOAD_OPTION_HANDLE + '"]');
    if (!fieldset) return null;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function isDoubleSided(value) {
    return value && value.toLowerCase().indexOf('double-sided') !== -1;
  }

  function updateUploadVisibility(wrapper) {
    var container = wrapper.querySelector('.custom-upload-container');
    if (!container) return;

    var uploadFront = container.querySelector('.upload-front');
    var uploadBack = container.querySelector('.upload-back');
    if (!uploadFront || !uploadBack) return;

    var value = getSelectedUploadValue(wrapper);

    if (isDoubleSided(value)) {
      container.classList.add('imprint-double');
    } else {
      container.classList.remove('imprint-double');
    }
  }

  function initImprintUploadToggle() {
    var wrappers = document.querySelectorAll('.variant-wrapper .custom-upload-container');
    wrappers.forEach(function (container) {
      var wrapper = container.closest('.variant-wrapper');
      if (!wrapper) return;

      updateUploadVisibility(wrapper);

      var fieldset = wrapper.querySelector('.variant-input-wrap[data-handle="' + UPLOAD_OPTION_HANDLE + '"]');
      if (fieldset) {
        fieldset.addEventListener('change', function () {
          updateUploadVisibility(wrapper);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImprintUploadToggle);
  } else {
    initImprintUploadToggle();
  }

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('.variant-wrapper .custom-upload-container').forEach(function (container) {
      var wrapper = container.closest('.variant-wrapper');
      if (wrapper) updateUploadVisibility(wrapper);
    });
  });
})();
